import { render, staticRenderFns } from "./PropertyOverview1.vue?vue&type=template&id=380383c4&"
import script from "./PropertyOverview1.vue?vue&type=script&lang=js&"
export * from "./PropertyOverview1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports